// src/entity-decoder.js


function animateBars(){
  [{id:"bar1",w:"30%"},{id:"bar2",w:"20%"},{id:"bar3",w:"50%"}].forEach(function(b){
    var el=document.getElementById(b.id);
    if(!el)return;
    var rect=el.closest(".alloc").getBoundingClientRect();
    if(rect.top<window.innerHeight-60&&!el.dataset.done){
      el.dataset.done="1";
      el.style.width=b.w;
    }
  });
}
window.addEventListener("scroll",animateBars);
animateBars();

(function () {
  var parser = new DOMParser();

  function decode(str) {
    return parser.parseFromString(str, 'text/html').documentElement.textContent;
  }

  function processNode(node) {
    if (node.nodeType === 3) {
      if (/&[#a-zA-Z0-9]+;/.test(node.nodeValue)) {
        node.nodeValue = decode(node.nodeValue);
      }
    } else if (node.nodeType === 1) {
      var t = node.tagName.toLowerCase();
      if (t === 'script' || t === 'style' || t === 'input' || t === 'textarea') return;
      for (var i = 0; i < node.childNodes.length; i++) {
        processNode(node.childNodes[i]);
      }
    }
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(processNode);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

})();